import { Texto } from '@gravitate-js/excalibrr'
import { useMemo } from 'react'
import { CellContainer } from './CellContainer'

export type ComparisonArgs<T> = {
  value?: T | null
  previousValue?: T | null
  isEqual?: (val1?: T | null, val2?: T | null) => boolean
}
/**@returns true if the values pass the comparison function, otherwise false */
export function compareCell<T>({ value, previousValue, isEqual }: ComparisonArgs<T>): boolean {
  const equalityFn = isEqual ?? ((val1?: T | null, val2?: T | null) => val1 === val2)
  return equalityFn(value, previousValue)
}

export type ComparisonCellProps<T> = {
  valueFormatted?: string | null
  children?: React.ReactNode
} & ComparisonArgs<T>
export function ComparisonCell<T>({ value, valueFormatted, previousValue, isEqual, children }: ComparisonCellProps<T>) {
  const match = useMemo(() => compareCell({ value, previousValue, isEqual }), [value, previousValue, isEqual])
  return (
    <CellContainer status={match ? 'success' : 'default'}>
      {children ?? <Texto>{valueFormatted ?? (value && typeof value === 'string' ? value : '')}</Texto>}
    </CellContainer>
  )
}
